export default __webpack_public_path__ + "static/media/DonationLayout.0c5fb855.png";